import { useParams, Link } from 'react-router-dom';
import { useProduct } from '../api/hooks';
import { Card } from '../components/Card';
import { Badge } from '../components/Badge';

export default function ProductDetail() {
  const { id } = useParams<{ id: string }>();
  const { data, isLoading, error } = useProduct(id);

  if (isLoading || !data) return <p className="text-arcforge-500">載入中…</p>;
  if (error) return <p className="text-red-600">錯誤：{(error as Error).message}</p>;

  const { product, config } = data;
  const enabledComponents = config
    ? Object.entries(config.config_json.components ?? {}).filter(
        ([, v]: [string, unknown]) => (v as { enabled?: boolean })?.enabled
      )
    : [];

  const adminComp = config?.config_json.components?.['admin-dashboard'] as
    | { enabled?: boolean; config?: { secret?: string } }
    | undefined;
  const adminUrl =
    adminComp?.enabled && adminComp.config?.secret
      ? `https://${product.id}.raymond-ihh-tw.workers.dev/admin?token=${encodeURIComponent(
          adminComp.config.secret
        )}`
      : null;

  return (
    <div className="space-y-4">
      <Link to="/" className="text-sm text-blue-600 hover:underline">
        ← 所有產品
      </Link>
      <div className="flex items-center gap-3">
        <h2 className="text-2xl font-bold text-arcforge-700">{product.name}</h2>
        <Badge>v{product.current_version}</Badge>
      </div>
      <p className="text-sm text-arcforge-500 font-mono">{product.id}</p>
      <div className="flex flex-wrap items-center gap-3">
        <a
          className="inline-block text-sm text-blue-600 hover:underline"
          href={`https://${product.id}.raymond-ihh-tw.workers.dev`}
          target="_blank"
          rel="noreferrer"
        >
          → 打開產品 {product.id}.raymond-ihh-tw.workers.dev
        </a>
        {adminUrl && (
          <a
            className="inline-block rounded bg-arcforge-700 px-3 py-1 text-xs font-semibold text-white hover:bg-arcforge-600"
            href={adminUrl}
            target="_blank"
            rel="noreferrer noopener"
          >
            後台
          </a>
        )}
      </div>

      {config && (
        <Card>
          <h3 className="text-sm font-semibold mb-2">Config</h3>
          <p className="text-xs text-arcforge-500">
            Version {config.version} · 由 {config.author} 建立
          </p>
          {enabledComponents.length > 0 && (
            <div className="mt-3 flex flex-wrap gap-2">
              {enabledComponents.map(([k]) => {
                const isAddon = k.startsWith('drink-') || k.startsWith('admin-');
                return (
                  <Badge key={k} tone={isAddon ? 'addon' : 'core'}>
                    {k}
                  </Badge>
                );
              })}
            </div>
          )}
          <details className="mt-3">
            <summary className="cursor-pointer text-xs text-arcforge-500 select-none">
              完整 YAML
            </summary>
            <pre className="mt-2 rounded bg-arcforge-50 p-3 text-xs overflow-x-auto whitespace-pre-wrap">
              {config.config_yaml}
            </pre>
          </details>
        </Card>
      )}

      {!config && (
        <Card>
          <p className="text-arcforge-500 text-sm">此產品尚未建立 config（異常狀態）</p>
        </Card>
      )}
    </div>
  );
}
